export default __webpack_public_path__ + "static/media/reset.b8db8f0c.svg";